module.exports = __webpack_public_path__ + "static/img/RisScan.48335a44.png";